import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import UsersContoller from "../../api/admin/users";
import { toast } from "react-toastify";
import Header from "../../components/admin/users/Header";
import useAdminUser from "../../hooks/useAdminUser";

export default function EditPrem() {
    const { id } = useParams();
    const { user, setUser } = useAdminUser(Number(id));
    const [prem, setPrem] = useState(user?.isPremium || false);

    const updatePrem = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const response = await UsersContoller.updatePrem(Number(id), prem);

        if (response.error) return toast(response.message);

        setUser(response.user);

        toast("Премиум обновлен");
    }, [id, prem, setUser]);

    useEffect(() => {
        setPrem(user?.isPremium || false);
    }, [user?.isPremium]);

    if (!user) return null;

    return <section className="main-part-dinamic">
        <div className="wrap-of-dinamic">
            <div className="main-header-of-page">
                Премиум
            </div>

            <Header user={user} />

            <form className="dinamic-content -cmr-users -other-pages-content " onSubmit={updatePrem}>
                <div className="-profile-setting mt40">
                    <div className="right-part-of-secondary-pages">
                        <div className="switch-2fa-wrap mt40" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                            <div className="checkbox-item">
                                <input type="radio" id="parametr1" name="parametr" checked={prem} onChange={() => setPrem(true)} />
                                <label htmlFor="parametr1" className="-green-info">Включен</label>
                            </div>
                            <div className="checkbox-item mt10">
                                <input type="radio" id="parametr2" name="parametr" checked={!prem} onChange={() => setPrem(false)} />
                                <label htmlFor="parametr2" className="-red-info">Выключен</label>
                            </div>
                        </div>
                        <button className="-save-btn mt20" style={{ marginTop: "30px" }} type="submit">Сохранить</button>
                    </div>
                </div>

            </form>
        </div>
    </section>
}